import { useTranslation } from 'react-i18next';

import { Box, Flex, Heading, Text, useToast } from '@chakra-ui/react';
import { DownloadCertificateButton, ShareButton } from '@udacity/udacity-certificate';

import { trackEvent } from '~/features/analytics/track-event';

import { Certificate } from '../model';

export function OwnerMessage({ fullName, certificate }: { fullName: string; certificate: Certificate }) {
  const { t } = useTranslation();
  const toast = useToast();

  return (
    <Box id='certificate-message'>
      <Box mb='16px'>
        <Heading as='h1' mb='8px' size='marketing-4xl'>
          {t('certificate.congratulations', { fullName })}
        </Heading>
        <Text>{t('certificate.greatJob')}</Text>
      </Box>
      <Flex gap='16px'>
        <DownloadCertificateButton
          pdfUrl={certificate.pdfUrl}
          onDownloadClick={() =>
            trackEvent({
              type: 'click',
              name: 'Download Graduation Certificate Clicked',
              label: 'Download',
              action: 'download_certificate_clicked',
              additionalAttributes: { program_key: certificate.programKey },
            })
          }
        />

        <ShareButton
          confirmUrl={certificate.confirmUrl || undefined}
          graduationDate={certificate.graduationDate as string}
          programTitle={certificate.programTitle as string}
          onCopyToClipboardClick={() => {
            toast({
              variant: 'success',
              title: t('certificate.linkCopied'),
            });
          }}
          onLinkedInClick={() => {
            trackEvent({
              type: 'click',
              name: 'Share on LinkedIn Clicked',
              label: 'Share on LinkedIn',
              action: 'share_certificate_on_linkedin_clicked',
              additionalAttributes: { program_key: certificate.programKey },
            });
          }}
          onShareClick={() => {
            trackEvent({
              type: 'click',
              name: 'Share Graduation Certificate Clicked',
              label: 'Share',
              action: 'share_certificate_clicked',
              additionalAttributes: { program_key: certificate.programKey },
            });
          }}
        />
      </Flex>
    </Box>
  );
}
